if (typeof ProductImageZoom === 'undefined') {
  class ProductImageZoom extends HTMLElement {
    constructor() {
      super()

      this.initialized()
    }

    initialized() {
      this.image = {
        active: false,
        src: '',
        posX: 0,
        posY: 0,
        wrapper: {
          top: 0,
          left: 0,
        },
        width: 0,
        height: 0,
      }

      this.zoomImageElm = this.querySelector('.js-product-image-zoom')
      if (this.zoomImageElm) {
        this.zoomImageElm.addEventListener('mousemove', (e) => {
          this.position(e)
        })

        this.zoomImageElm.addEventListener('mouseout', (e) => {
          this.zoomOut()
        })

        this.addEventListener('click', (e) => {
          if (this.image.active) {
            this.zoomOut()
          } else {
            this.zoomImage(e, this.dataset.src)
          }
        })
      }
    }

    zoomOut() {
      this.zoomImageElm.classList.add('hidden')
      this.classList.remove('cursor-zoom-out')
      this.classList.add('cursor-zoom-in')
      this.image.active = false
    }

    zoomIn() {
      this.zoomImageElm.classList.remove('hidden')
      this.classList.remove('cursor-zoom-in')
      this.classList.add('cursor-zoom-out')
      this.image.active = true
    }

    zoomImage(event, string) {
      const img = new Image()
      img.src = string
      img.onload = this.openZoom(event, string)
    }

    openZoom(event, string) {
      this.zoomIn()
      this.image.src = string
      this.zoomImageElm.style.backgroundImage = `url(${this.image.src})`
      this.position(event)
    }

    measuring() {
      this.image.wrapper = this.getBoundingClientRect()
      this.image.width = this.clientWidth
      this.image.height = this.clientHeight
    }

    position(event) {
      this.measuring() // Can't be on mounted cause need to calculate because of window scroll or gallery chaged
      const x = event.clientX - this.image.wrapper.left
      const y = event.clientY - this.image.wrapper.top
      this.image.posX = this.image.width / 2 - x
      this.image.posY = this.image.height / 2 - y

      this.zoomImageElm.style.transform = `translate(${this.image.posX}px, ${this.image.posY}px)`
    }
  }

  if (customElements.get('product-image-zoom') === undefined) {
    customElements.define('product-image-zoom', ProductImageZoom)
  }
}

if (typeof ProductAccordions === 'undefined') {
  class ProductAccordions extends HTMLElement {
    constructor() {
      super()

      this.accordions = this.querySelectorAll('.js-product-accordion')
      for (let i = 0; i < this.accordions.length; i++) {
        this.accordions[i].addEventListener(
          'click',
          (e) => {
            this.toggleAccordion(i)
          },
          false
        )
      }
    }

    toggleAccordion(i) {
      this.accordions[i].classList.toggle('opened')
      const contentDiv = this.accordions[i].closest('div').querySelector('div')
      if (this.accordions[i].classList.contains('opened')) {
        contentDiv.classList.remove('h-0')
        contentDiv.classList.add(...['pb-[28px]', 'md:pb-[20px]'])
      } else {
        contentDiv.classList.add('h-0')
        contentDiv.classList.remove(...['pb-[28px]', 'md:pb-[20px]'])
      }
    }
  }

  if (customElements.get('product-accordions') === undefined) {
    customElements.define('product-accordions', ProductAccordions)
  }
}

if (typeof ProductPage === 'undefined') {
  class ProductPage extends HTMLElement {
    constructor() {
      super()

      this.activeVariant = _productJson.variants.find(
        (variant) => variant.id === Number(this.dataset.variant)
      )

      this.productNotifyMe = this.querySelector('#js-product-back-in-stock').value?.toString()?.toLowerCase() === 'true'
      this.renderSwatches()
      this.renderSizes()

      this.addToButton = this.querySelector('#js-form-submit')
      // hijacks submit button
      this.querySelector('#js-product-form').addEventListener('submit', (e) => {
        e.preventDefault()
        if (this.activeVariant.available) {
          this.addToCart()
        } else {
          document.querySelector('#backinstockForm--SKU').value = this.activeVariant.sku
          window.toggleBackInStockModal(false)
        }
      })

      this.renderImageCarousel()
      // firing these two in constructor on page load to see if this fixes the active variant
      // image issue on page load from collections grid
      this.setActiveVariant()
      this.changeSwatchImages()

      this.updateInventory = this.updateInventory.bind(this)
      this.refreshInventory = this.refreshInventory.bind(this)
      this.updateButtons()
      this.changeSwatchImages()
    }

    addToCart() {
      this.addToButton.disabled = true

      const body = JSON.stringify({
        id: this.activeVariant.id,
        quantity: 1,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      })

      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.text())
        .then((state) => {
          const parsedState = JSON.parse(state)

          const cartItems = window.__CART__.items
          let alreadyInCart = false
          if (cartItems.length) {
            window.__CART__.items.map((item) => {
              if (item.id === parsedState.id) {
                item.quantity = parsedState.quantity
                alreadyInCart = true
              }
            })
          }
          if (!alreadyInCart) {
            window.__CART__.items.push(parsedState)
          }

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document
                .getElementById(section.id)
                .querySelector(section.selector) ||
              document.getElementById(section.id)
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            )
          })
          this.updateInventory()
          this.showMiniCart()
        })
        .catch((e) => {
          console.error(e)
        })
    }

    refreshInventory() {
      this.updateButtons()
      this.updateSizes()
    }

    updateInventory() {
      const variantInventory = this.querySelector(
        `.js-variants-select option[data-id="${this.activeVariant.id}"]`
      )

      if (variantInventory) {
        let inventoryQuantity = Number(variantInventory.dataset.inventoryQuantity)
        variantInventory.setAttribute(
          'data-inventory-quantity',
          inventoryQuantity - 1
        )

        if (_variantInventories && _variantInventories[this.activeVariant.id.toString()]) {
          _variantInventories[this.activeVariant.id.toString()].inventory_quantity -= 1
        }
      }

      this.updateButtons()
      this.updateSizes()
    }

    getSectionsToRender() {
      return [
        {
          id: 'js-mini-cart',
          section: document.getElementById('js-mini-cart').dataset.id,
          selector: '.js-contents',
        },
      ]
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML
    }

    showMiniCart() {
      window.dispatchEvent(new CustomEvent('ToggleMiniCart'))
      window.dispatchEvent(new CustomEvent('wantable cart updated'))
    }

    renderImageCarousel() {
      this.splideElement = this.querySelector('.splide')

      const option = {
        arrows: false,
        type: 'fade',
        rewind: true,
        classes: {
          pagination: 'splide__pagination bottom-[18px]',
          page: 'splide__pagination__page opacity-100 w-[10px] h-[10px] bg-grey-280 hover:bg-secondary-yellow hover:opacity-100 mx-[10px]',
        },
      }

      const splide = new Splide(this.splideElement, option)

      splide.mount()
      splide.refresh()

      splide.on('resize', () => {
        splide.refresh()
      })
    }

    renderSwatches() {
      this.swatchesContainer = this.querySelector('.js-product-swatches')
      this.activeSwatchValue = this.querySelector('.js-active-swatch-value')
      if (this.swatchesContainer) {
        this.swatchList = Array.from(
          this.swatchesContainer.querySelectorAll('li')
        )
        this.activeSwatch = this.swatchList.find((swatch) =>
          swatch.classList.contains('active')
        )
        this.swatchPosition = this.swatchesContainer.dataset.position

        for (let i = 0; i < this.swatchList.length; i++) {
          this.swatchList[i].addEventListener(
            'mouseover',
            (e) => {
              this.previewSwatchName(
                this.swatchList[i].getAttribute('data-color')
              )
            },
            false
          )

          this.swatchList[i].addEventListener(
            'mouseout',
            (e) => {
              this.showActiveSwatchName()
            },
            false
          )

          this.swatchList[i].addEventListener(
            'click',
            (e) => {
              this.activeSwatch = this.swatchList[i]
              this.showActiveSwatchName()
              this.changeSwatch()
            },
            false
          )
        }
      }
    }

    previewSwatchName(swatchName) {
      this.activeSwatchValue.textContent = swatchName
    }

    showActiveSwatchName() {
      this.activeSwatchValue.textContent =
        this.activeSwatch.getAttribute('data-color')
    }

    changeSwatchImages() {
      const IMAGE_ALT_DELIMITER = ' $|& ';

      this.imagesContainer = this.querySelector('.js-product-images')
      this.imagesContainer.innerHTML = ''
      this.imagesContainerCarousel = this.querySelector('.splide__list')
      this.imagesContainerCarousel.innerHTML = ''

      const swatch = this.activeSwatch.getAttribute('data-color')
      const images = _productJson.media
      let swatchImages = images
      if (swatch) {
        swatchImages = images.filter((image) => {
          return image?.alt && image.alt.split(IMAGE_ALT_DELIMITER)[0].toLowerCase() === swatch.toLowerCase()
        })
        if (!swatchImages.length) {
          swatchImages = images
        }
      }

      if (swatchImages.length) {
        swatchImages.forEach((img) => {
          this.renderImage(img)
          this.renderImageMobile(img)
        })

        this.querySelectorAll('product-image-zoom').forEach((item) =>
          item.initialized()
        )

        this.renderImageCarousel()
        if (
          swatchImages.length === 1 &&
          this.querySelector('.splide__pagination')
        ) {
          this.querySelector('.splide__pagination').classList.add('invisible')
        } else if (
          swatchImages.length > 1 &&
          this.querySelector('.splide__pagination')
        ) {
          this.querySelector('.splide__pagination').classList.remove(
            'invisible'
          )
        }
      }
    }

    renderImage(img) {
      const node = document.createElement('product-image-zoom')
      node.className =
        'relative rounded-[10px] h-0 overflow-hidden cursor-zoom-in'
      node.style.paddingTop = `${100 / img.aspect_ratio}%`
      node.dataset.src = img.src
      const contents =
        `<img class="absolute top-0 left-0 w-full h-full object-cover rounded-[10px]" src="${img.src}" alt="${img.alt}" />` +
        '<div class="js-product-image-zoom absolute hidden -top-1/2 -left-1/2 w-[200%] h-[200%] bg-cover bg-no-repeat bg-center cursor-zoom-out"></div>'
      node.innerHTML = contents
      this.imagesContainer.appendChild(node)
    }

    renderImageMobile(img) {
      const node = document.createElement('li')
      node.className = 'splide__slide'
      node.innerHTML = `<img class="w-full h-full object-contain" src="${img.src}" alt="${img.alt}" />`
      this.imagesContainerCarousel.appendChild(node)
    }

    changeSwatch() {
      this.swatchList.forEach((swatch) => {
        swatch.classList.remove('active')
      })

      this.activeSwatch.classList.add('active')

      this.changeSwatchImages()
      this.setActiveVariant()
      this.updateSizes()
      this.updateModelInfo()
    }

    updateModelInfo() {
      this.modelContainer = this.querySelector('.js-product-model')
      if (this.modelContainer) {
        this.modelContainer.innerHTML = ''
        const currentSwatchColor = this.activeSwatch.getAttribute('data-color');
        const modelInfo = _productMetafieldsAccentuateJson &&
                            _productMetafieldsAccentuateJson.model_info[currentSwatchColor]

        if (!modelInfo || Object.keys(modelInfo).length == 0) return;

        let imgContent = ''
        let infoList = []
        const modelInfoKeys = Object.keys(modelInfo);
        if (modelInfoKeys.includes('image_url')) {
          imgContent = `<div class="w-[25px] h-[25px] rounded-full"><img src="${modelInfo.image_url}" alt="${modelInfo.name}" class="w-full h-full object-cover rounded-full" /></div>`
        }
        ['Height', 'Bust', 'Hips', 'Waist', 'Chest', 'Wearing Size'].forEach((attr) => {
          if (modelInfoKeys.includes(attr)) {
            infoList.push(`<span class="font-bold">${attr}:</span> ${modelInfo[attr]}`)
          }
        })

        const node = document.createElement('div')
        node.className =
          'w-full mt-[28px] md:mt-[25px] rounded-[5px] bg-grey-100 pt-[16px] pb-[28px] md:pb-[20px] px-[24px]'
        node.innerHTML =
          '<div class="flex items-center">' +
          ` ${imgContent}` +
          ' <span class="font-primary font-bold text-desktop-heading-6 -tracking-[0.25px] pl-[6px]">Model Info:</span>' +
          '</div>' +
          '<div class="pt-[5px] text-[14px] leading-[17px]">' +
          ` ${modelInfo.name} is ${infoList.join(' | ')}` +
          '</div>'
        this.modelContainer.appendChild(node)
      }
    }

    hasOption(name) {
      return _productJson.options.find((opt) => opt.toLowerCase() === name)
    }

    setActiveVariant() {
      let optName = 'color'
      let variants = deepClone(_productJson.variants)
      if (this.hasOption(optName)) {
        variants = variants.filter(
          (variant) => variant[`option${this.swatchPosition}`] === this.activeSwatch.getAttribute('data-color')
        )
      }

      optName = 'size'
      if (this.hasOption(optName)) {
        const activeVariant = this.findVariant(variants, this.activeSize, 'size', true)

        if (activeVariant) {
          this.activeVariant = activeVariant
        } else {
          const availableVariants = variants.filter((variant) => variant.available)
          if (availableVariants.length > 0) {
            this.activeVariant = availableVariants[0]
          } else {
            this.activeVariant = variants.find(
              (variant) => variant[`option${this.sizePosition}`] === this.activeSize.getAttribute('data-size')
            )
          }
        }
      } else {
        this.activeVariant = variants[0]
      }

      this.changeProductInfo()
    }

    changeProductInfo() {
      this.updatePrice()
      this.updateButtons()
    }

    updatePrice() {
      this.querySelector('.js-product-price-original').textContent =
        window.formatter.format(this.activeVariant.price / 100)
      if (this.activeVariant.compare_at_price) {
        this.querySelector('.js-product-price-compare').textContent =
          window.formatter.format(this.activeVariant.compare_at_price / 100)
        this.querySelector('.js-product-price-compare').classList.remove('hidden')
      } else {
        if (!this.querySelector('.js-product-price-compare').classList.contains('hidden')) {
          this.querySelector('.js-product-price-compare').classList.add('hidden')
        }
      }
    }
    showButtonIcon(icon) {
      Object.values(_buttonIcons).forEach((_icon) => this.querySelector(`.js-${_icon}`).classList.add('hidden'))
      this.querySelector(`.js-${icon}`).classList.remove('hidden')
    }

    /**
     * @param {Boolean} allInventoryFromGhosts
     * @returns {string}
     */
    preOrderDivHTML(allInventoryFromGhosts) {
      const text = allInventoryFromGhosts ? 'This item ships within one week!' : ''

      return `<div class="w-full text-center py-10 font-primary text-desktop-heading-6 -tracking-[0.25px]">
        ${text}
      </div>`
    }

    /**
     * Returns variant inventory info
     *
     * @param {{id: Number}} variant
     * @returns {{available: Boolean,
                  inventory_quantity: Number,
                  inventory_policy: string,
                  ghost_quantity: Number}}
     */
    variantInventory(variant) {
      if (typeof _variantInventories !== 'undefined' && _variantInventories[variant.id.toString()]) {
        return _variantInventories[variant.id.toString()]
      }

      // if the above hash isn't defined fall back to select options searching
      const variantInventoryOption = this.querySelector(`.js-variants-select option[data-id="${variant.id}"]`)

      let available = false
      let inventoryPolicy = 'deny'
      let inventoryQuantity = 0
      let ghostQuantity = 0

      if (variantInventoryOption) {
        inventoryPolicy = variantInventoryOption.dataset.inventoryPolicy
        inventoryQuantity = Number(variantInventoryOption.dataset.inventoryQuantity)
        ghostQuantity = Number(variantInventoryOption.dataset.inventoryGhostQuantity)
        available = inventoryQuantity > 0
      }

      return {
        available,
        inventory_quantity: inventoryQuantity,
        inventory_policy: inventoryPolicy,
        ghost_quantity: ghostQuantity
      }
    }

    soldOutButtonState() {
      this.querySelector('.js-variant-preorder').innerHTML = this.preOrderDivHTML(false);

      this.addToButton.querySelector('p').innerHTML =
        _buttonLabels['sold_out']
      if (!this.querySelector('.js-icon-atc').classList.contains('hidden')) {
        this.querySelector('.js-icon-atc').classList.add('hidden')
      }
      this.addToButton.disabled = true
    }

    /**
     * @param {Boolean} allInventoryFromGhosts
     */
    setButtonStateAvailable(allInventoryFromGhosts) {
      this.querySelector('.js-variant-preorder').innerHTML = this.preOrderDivHTML(allInventoryFromGhosts);

      this.addToButton.querySelector('p').innerHTML = _buttonLabels['add']
      this.querySelector('.js-icon-atc').classList.remove('hidden')

      this.addToButton.disabled = false
    }

    /**
     * Not actively used. Keeping just in case
     * @param {string} preOrderText
     */
    preOrderButtonState(preOrderText) {
      this.updatePreorderText(preOrderText)

      this.addToButton.querySelector('p').innerHTML = _buttonLabels['preorder']
      if (!this.querySelector('.js-icon-atc').classList.contains('hidden')) {
        this.querySelector('.js-icon-atc').classList.add('hidden')
      }

      this.addToButton.disabled = false
    }

    notifyMeButtonState() {
      //this.showButtonIcon(_buttonIcons['notify_me'])
      this.querySelector('.js-variant-preorder').innerHTML = ''
      //this.addToButton.querySelector('p').innerHTML = _buttonLabels['notify_me']
      this.querySelector('.size-BIS').removeAttribute('id')
      this.querySelector('.size-BIS').classList.add('hidden')
      this.querySelector('.btn-BIS').classList.remove('hidden')
      this.querySelector('#js-form-submit').classList.add('hidden')
    }

    updateButtons() {
      // set things to default
      this.addToButton.disabled = true
      this.showButtonIcon(_buttonIcons['default'])
      // very important. sets the id of variant to add to cart
      this.querySelector('#js-variant-id').value = this.activeVariant.id
      if (this.querySelector('.size-BIS') != null) {
        this.querySelector('.size-BIS').dataset.variantId = this.activeVariant.id
      }
      this.querySelector('.btn-BIS').dataset.variantId = this.activeVariant.id

      const {
        available: inventoryAvailable,
        inventory_policy: inventoryPolicy,
        inventory_quantity: inventoryQuantity,
        ghost_quantity: ghostQuantity
      } = this.variantInventory(this.activeVariant)

      let available = inventoryAvailable;

      const allInventoryFromGhosts = inventoryQuantity === ghostQuantity;

      if (inventoryPolicy === 'deny' && inventoryQuantity < 1) available = false

      const preorderInfo = [].find((item) =>
        Object.keys(item).includes(this.activeVariant.id.toString())
      )
      const preOrderText = preorderInfo ? preorderInfo[this.activeVariant.id] : ''

      if (preOrderText && available) {
        this.preOrderButtonState(preOrderText)
      } else if (available) {
        this.setButtonStateAvailable(allInventoryFromGhosts)
        if (this.querySelector('.size-BIS') != null) {
          this.querySelector('.size-BIS').setAttribute('id', 'BIS_trigger')
          this.querySelector('.size-BIS').classList.remove('hidden')
        }
        this.querySelector('.btn-BIS').classList.add('hidden')
        this.querySelector('#js-form-submit').classList.remove('hidden')
      } else if (!available) {
        if (this.productNotifyMe) {
          this.notifyMeButtonState()
        } else {
          this.soldOutButtonState()
        }
      }
    }

    updatePreorderText(text) {
      this.querySelector('.js-variant-preorder').innerHTML = ''
      const node = document.createElement('div')
      node.className = 'w-full text-center py-10 font-primary text-desktop-heading-6 -tracking-[0.25px]'
      node.innerHTML = text
      this.querySelector('.js-variant-preorder').appendChild(node)
    }

    changeActiveSize() {
      this.activeSize = this.sizeList.find(
        (size) =>
          size.getAttribute('data-size') ===
          this.activeVariant[`option${this.sizePosition}`]
      )
    }

    findVariant(variants, option, type, allowUnavailable) {
      let available = true
      return variants.find((variant) => {
        available = allowUnavailable ? true : this.isAvailableVariant(variant)

        if (type === 'any') return available;
        if (this.productNotifyMe) available = true

        return (
          variant[`option${this.sizePosition}`] === option.getAttribute('data-size') && available
        )
      })
    }

    isAvailableVariant(variant) {
      const {
        available: inventoryAvailable,
        inventory_policy: inventoryPolicy,
        inventory_quantity: inventoryQuantity,
        ghost_quantity: ghostQuantity
      } = this.variantInventory(variant)

      let available = inventoryAvailable;

      if (inventoryPolicy === 'deny' && inventoryQuantity < 1) available = false

      return available
    }

    updateURLState() {
      window.history.replaceState(null, null, `?variant=${this.activeVariant.id}`);
    }

    updateSizes() {
      if (!this.sizesContainer) return;

      this.changeActiveSize()
      this.changeSize()

      let variants = deepClone(_productJson.variants)
      variants = variants.filter(
        (variant) =>
          variant[`option${this.swatchPosition}`] ===
          this.activeSwatch.getAttribute('data-color')
      )

      let sizeVariant = null
      let labelClasses = ['cursor-default', 'opacity-50', 'test-oos']

      for (let i = 0; i < this.sizeList.length; i++) {
        sizeVariant = this.findVariant(variants, this.sizeList[i], 'size', false)
        if (sizeVariant) {
          this.sizeList[i].classList.remove('unavailable')
          this.sizeList[i].querySelector('label').classList.remove(...labelClasses)
          this.sizeList[i].querySelector('input').disabled = false

          if (!this.isAvailableVariant(sizeVariant)) {
            this.sizeList[i].querySelector('label').classList.add('test-oos')
          }
        } else {
          if (!this.sizeList[i].classList.contains('unavailable')) {
            this.sizeList[i].classList.add('unavailable')
          }
          this.sizeList[i].classList.remove('bg-black')
          this.sizeList[i].classList.remove('text-white')
          if (!this.sizeList[i].querySelector('label').classList.contains('opacity-50')) {
            this.sizeList[i].querySelector('label').classList.add(...labelClasses)
          }
          this.sizeList[i].querySelector('input').disabled = true
        }
      }
    }

    renderSizes() {
      this.sizesContainer = this.querySelector('.js-product-sizes')
      this.activeSizeValue = this.querySelector('.js-active-size-value')
      if (this.sizesContainer) {
        this.sizeList = Array.from(this.sizesContainer.querySelectorAll('li'))
        this.activeSize = this.sizeList.find((swatch) =>
          swatch.classList.contains('active')
        )
        this.sizePosition = this.sizesContainer.dataset.position

        for (let i = 0; i < this.sizeList.length; i++) {
          this.sizeList[i].addEventListener(
            'mouseover',
            (e) => {
              this.previewSizeName(this.sizeList[i].getAttribute('data-size'))
            },
            false
          )

          this.sizeList[i].addEventListener(
            'mouseout',
            (e) => {
              this.showActiveSizeName()
            },
            false
          )

          this.sizeList[i].addEventListener(
            'click',
            (e) => {
              this.activeSize = this.sizeList[i]
              this.showActiveSizeName()
              this.changeSize()
              this.setActiveVariant()
              this.updateModelInfo()
              this.updateURLState()
            },
            false
          )
        }
      }
    }

    previewSizeName(sizeName) {
      this.activeSizeValue.textContent = sizeName
    }

    showActiveSizeName() {
      this.activeSizeValue.textContent = this.activeSize.getAttribute('data-size')
    }

    changeSize() {
      const classes = ['bg-black', 'text-white', 'active']
      this.sizeList.forEach((size) => {
        size.classList.remove(...classes)
        size.querySelector('input').checked = false
      })

      this.activeSize.classList.add(...classes)
      this.activeSize.querySelector('input').checked = true
    }
  }

  if (customElements.get('product-page') === undefined) {
    customElements.define('product-page', ProductPage)
  }
}
